import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { NewPriceChange, PageResource, PriceChange, PriceChangeImportResponse, PriceChangeSearch } from '@portal-front-end/models';
import { Observable } from 'rxjs';
import { API_SERVER_TOKEN } from '../api-server-token';

@Injectable({ providedIn: 'root' })
export class PriceChangeApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly PRICE_CHANGE_API_URL = `${this.apiServer}/price-change`;

    getAllPriceChanges(orgId: string, page: number, size: number, profileIds: number[] = [], search: PriceChangeSearch = null): Observable<PageResource<PriceChange>> {
        const params: { [param: string]: string } = { 'organisationId': orgId, 'page': page.toString(), 'size': size.toString() };
        if (profileIds.length) {
            params['profileIds'] = profileIds.join();
        }
        if (search?.organisationIds?.length) {
            params['organisationIds'] = search.organisationIds.join();
        }
        if (search?.effectiveDateFrom) {
            params['effectiveDateFrom'] = search.effectiveDateFrom;
        }
        if (search?.effectiveDateTo) {
            params['effectiveDateTo'] = search.effectiveDateTo;
        }
        if (search?.statusIds?.length) {
            params['statusIds'] = search.statusIds.join();
        }
        if (search?.orderCode) {
            params['orderCode'] = search.orderCode;
        }
        if (search?.supplierReference) {
            params['supplierReference'] = search.supplierReference;
        }
        return this.http.get<PageResource<PriceChange>>(`${this.PRICE_CHANGE_API_URL}/page`, { params });
    }

    createNewPriceChange(newPriceChange: NewPriceChange): Observable<PriceChange> {
        return this.http.post<PriceChange>(`${this.PRICE_CHANGE_API_URL}`, newPriceChange);
    }

    approvePriceChange(priceChangeIds: number[]) {
        return this.http.put(`${this.PRICE_CHANGE_API_URL}/price-change-status`, {
            priceChangeStatusId: 1,
            priceChangeIdList: priceChangeIds
        });
    }

    uploadPriceChangeFile(orgId: string, profileIds: number[],isCreateProdOrgProfile:boolean, formData: FormData): Observable<PriceChangeImportResponse> {
        return this.http.post<PriceChangeImportResponse>(`${this.apiServer}/import-price-changes`, formData,{
            params: {
                organisationId: orgId,
                profileIds: profileIds.join(),
                isCreateProdOrgProfile:isCreateProdOrgProfile.toString(),
            }
        });
    }


}
